import { Button } from '@up2stay/up2promo-ui';

import { useEntitlements } from '@/core/hooks/use-entitlements';
import {
  resolvePrimaryAction,
  type OverviewHealthLabels,
} from './location-detail-overview-tab';
import {
  LocationHealthDots,
  type LocationHealthLabels,
} from './location-health-indicators';
import {
  type LocationHealthSummary,
  locationNeedsAttention,
} from './location-health';

type LocationDetailHeaderActionsProps = {
  locationHealth: LocationHealthSummary | null;
  linkedProductCount: number;
  overviewHealthLabels: OverviewHealthLabels;
  listHealthLabels: LocationHealthLabels;
  onNavigateTab: (tab: string) => void;
  onViewProducts: () => void;
};

export function LocationDetailHeaderActions({
  locationHealth,
  linkedProductCount,
  overviewHealthLabels,
  listHealthLabels,
  onNavigateTab,
  onViewProducts,
}: LocationDetailHeaderActionsProps) {
  const { isFeatureEnabled } = useEntitlements();
  const includeReputation = isFeatureEnabled('feature.reputation');
  const healthScope = { includeReputation };
  const headerRepairAction = locationHealth
    ? resolvePrimaryAction(
        locationHealth,
        linkedProductCount,
        overviewHealthLabels,
        healthScope,
      )
    : null;
  const showHeaderTriage =
    !!locationHealth && locationNeedsAttention(locationHealth, healthScope);

  if (!showHeaderTriage && !headerRepairAction) {
    return null;
  }

  return (
    <div className="flex w-full min-w-0 max-w-full flex-wrap items-center justify-start gap-2 md:justify-end">
      {showHeaderTriage && locationHealth ? (
        <LocationHealthDots
          health={locationHealth}
          labels={listHealthLabels}
          includeReputation={includeReputation}
          className="hidden sm:flex"
        />
      ) : null}
      {headerRepairAction ? (
        <Button
          size="md"
          className="w-full max-w-full md:w-auto"
          onClick={() => {
            if (headerRepairAction.kind === 'products') {
              onViewProducts();
              return;
            }
            onNavigateTab(headerRepairAction.tab);
          }}
        >
          <span className="truncate">{headerRepairAction.label}</span>
        </Button>
      ) : null}
    </div>
  );
}
